import keepAlive from '../../util/keepAlive';

const privatePage = [
  {
    path: '/primaryHotList',
    name: '私募产品',
    component: () => import ('@views/private/primaryHotListNew.vue'),
    meta: {
      title: '一级市场详情', //私募详情
      singleHead: true,
      keepAlive: true,
      useCatch: false, //是否用缓存
    },
  },
  // {
  //     path: "/primaryHotList",
  //     name: "私募热销",
  //     component: () => import("@views/private/primaryHotList.vue"),
  //     meta: {
  //         title: "一级市场详情",//私募详情
  //         singleHead: true,
  //         keepAlive:true,
  //         useCatch: false //是否用缓存
  //     },
  // },
  {
    path: '/primaryAllProduct',
    name: '全部产品',
    component: () => import ('@views/private/primaryAllProduct.vue'),
    meta: {
      title: '全部产品', //私募详情
      singleHead: true,
      keepAlive: true,
      useCatch: false, //是否用缓存
    },
  },
  {
    path: '/primaryProductPreView',
    name: '全部产品',
    component: () => import ('@views/private/primaryProductPreView.vue'),
    meta: {
      title: '全部产品', //私募详情
      singleHead: true,
    },
  },
  {
    path: '/primaryMarketDetail',
    name: '产品详情',
    component: () => import ('@views/private/primaryDetail.vue'),
    meta: {
      title: '产品详情', //私募详情
      singleHead: true,
      keepAlive: true,
      useCatch: false, //是否用缓存
    },
  },
  {
    path: '/performanceReport',
    name: '绩效归因报告',
    component: () => import ('@views/private/performanceReport.vue'),
    meta: {
      title: '绩效归因报告',
      singleHead: true,
    },
  },
  {
    path: '/primaryMarketLogin',
    name: '验证手机号',
    component: () => import ('@views/private/share/shareLogin.vue'),
    meta: {
      title: '',
      singleHead: true,
    },
  },
  {
    path: '/rateDetail',
    name: '费率明细',
    component: () => import ('@views/private/rateDetail.vue'),
    meta: {
      title: '一级市场详情',
      singleHead: true,
    },
  },
  {
    path: '/sendFilePage',
    name: '发送文件确认',
    component: () => import ('@views/private/masterMarket/sendFilePage.vue'),
    meta: {
      title: '一级市场详情',
      singleHead: true,
    },
  },
  {
    path: '/sendFilePageCom',
    name: '发送文件确认',
    component: () => import ('@views/private/masterMarket/sendFilePageCom.vue'),
    meta: {
      title: '一级市场详情',
      singleHead: true,
    },
  },
  {
    path: '/historyVal',
    name: '历史净值',
    component: () => import ('@views/private/moreHistoryValue.vue'),
    meta: {
      title: '一级市场详情',
    },
  },
  {
    path: '/historyAnnualData',
    name: '历史七日年化',
    component: () => import ('@views/private/moreAnnualData.vue'),
    meta: {
      title: '一级市场详情',
    },
  },
  {
    path: '/signProcess',
    name: '电子签约流程',
    component: () => import ('@views/private/signProcess.vue'),
    meta: {
      title: '私募交易',
    },
  },
  {
    path: '/toDoReminder',
    name: '代办提醒',
    component: () => import ('@views/private/toDoReminder.vue'),
    meta: {
      title: '代办提醒',
    },
  },
  {
    path: '/reminderDetail',
    name: '交易详情',
    component: () => import ('@views/private/reminderDetail.vue'),
    meta: {
      title: '交易详情',
    },
  },
  {
    path: '/orgDetail',
    name: '机构详情',
    component: () => import ('@views/private/orgDetail.vue'),
    meta: {
      title: '机构详情',
      showBg: true,
    },
  },
  {
    path: '/allMaterialsInfo',
    name: '相关文档列表',
    component: () => import ('@views/private/masterMarket/wordList.vue'),
    meta: {
      singleHead: true,
    },
  },
  {
    path: '/orgIntro',
    name: '机构简介',
    component: () => import ('@views/private/masterMarket/orgDetail.vue'),
    meta: {
      singleHead: true,
      keepAlive: true,
    },
  },
  {
    path: '/sharePrivateDetail',
    name: '产品详情',
    component: () => import ('@views/private/share/primaryDetail.vue'),
    meta: {
      title: '产品详情', //私募详情
      singleHead: true,
    },
  },
  {
    path: '/priFundManger', //历任基金经理
    name: 'priFundManger',
    component: () => import ('@views/private/masterMarket/fundManger.vue'),
    meta: {
      title: '基金经理', //基金经理
      singleHead: true,
    },
  },
  {
    path: '/investmentAnalysis', //投资分析
    name: 'investmentAnalysis',
    component: () => import ('@views/assets/investmentAnalysis/index.vue'),
    meta: {
      title: '投资分析', //基金经理
      singleHead: true,
      keepAlive: true,
    },
  },
];
export default privatePage;
